const gql = String.raw
import * as SEO from './seo'
import * as COMMON from './common'
import { SITENAME } from '../../utils/siteConfig'

export const PAGE_BY_SLUG = gql`
  query GetPageBySlug($slug: ID!) {
    page(id: $slug, idType: URI) {
      slug
      databaseId
      id

      ${SEO.SEO_CONFIG}

      signaturePageFields {
        contentBuilder {
          ... on Page_Signaturepagefields_ContentBuilder_Hero {
            fieldGroupName
            headline
            tagline
            title
          }
          ... on Page_Signaturepagefields_ContentBuilder_MediaImage {
            fieldGroupName
            variant
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          ... on Page_Signaturepagefields_ContentBuilder_RichText {
            fieldGroupName
            text
          }
          ... on Page_Signaturepagefields_ContentBuilder_MediaGallery {
            fieldGroupName
            items {
              caption
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
          }
          ... on Page_Signaturepagefields_ContentBuilder_Contenttwoimages {
            captionLeft
            captionRight
            fieldGroupName
            imageLeft {
              ${COMMON.IMAGE_FIELDS}
            }
            imageRight {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          ... on Page_Signaturepagefields_ContentBuilder_MediaVideo {
            fieldGroupName
            video
            posterImage {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          ... on Page_Signaturepagefields_ContentBuilder_ItemsList {
            fieldGroupName
            items {
              description
              title
            }
          }
          ... on Page_Signaturepagefields_ContentBuilder_Billboard {
            description
            headline
            showCta
            fieldGroupName
            cta {
              ${COMMON.LINK_FIELDS}
            }
          }
          ... on Page_Signaturepagefields_ContentBuilder_TwoColumnsMedia {
            description
            fieldGroupName
            headline
            imageAlignment
            title
            imageCaption
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          ... on Page_Signaturepagefields_ContentBuilder_Cta {
            fieldGroupName
            cta {
              ${COMMON.LINK_FIELDS}
            }
          }
        }
      }

      template {
        templateName
      }
    }
  }
`

// Get all the slugs of Published pages for static path generation
export const GET_ALL_PAGES_WITH_SLUG_QUERY = gql`
  query AllPagesByBusinessUnit($term: [String]!) {
    pages(
      first: 9999
      where: {
        taxQuery: { taxArray: { taxonomy: BUSINESSUNIT, terms: $term, field: SLUG } }
      }
    ) {
      nodes {
        slug
        databaseId
        id

        ${SEO.SEO_CONFIG}

        signaturePageFields {
          contentBuilder {
            ... on Page_Signaturepagefields_ContentBuilder_Hero {
              fieldGroupName
              headline
              tagline
              title
            }
            ... on Page_Signaturepagefields_ContentBuilder_MediaImage {
              fieldGroupName
              variant
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
            ... on Page_Signaturepagefields_ContentBuilder_RichText {
              fieldGroupName
              text
            }
            ... on Page_Signaturepagefields_ContentBuilder_MediaGallery {
              fieldGroupName
              items {
                caption
                image {
                  ${COMMON.IMAGE_FIELDS}
                }
              }
            }
            ... on Page_Signaturepagefields_ContentBuilder_Contenttwoimages {
              captionLeft
              captionRight
              fieldGroupName
              imageLeft {
                ${COMMON.IMAGE_FIELDS}
              }
              imageRight {
                ${COMMON.IMAGE_FIELDS}
              }
            }
            ... on Page_Signaturepagefields_ContentBuilder_MediaVideo {
              fieldGroupName
              video
              posterImage {
                ${COMMON.IMAGE_FIELDS}
              }
            }
            ... on Page_Signaturepagefields_ContentBuilder_ItemsList {
              fieldGroupName
              items {
                description
                title
              }
            }
            ... on Page_Signaturepagefields_ContentBuilder_Billboard {
              description
              headline
              showCta
              fieldGroupName
              cta {
                ${COMMON.LINK_FIELDS}
              }
            }
            ... on Page_Signaturepagefields_ContentBuilder_TwoColumnsMedia {
              description
              fieldGroupName
              headline
              imageAlignment
              title
              imageCaption
              image {
                ${COMMON.IMAGE_FIELDS}
              }
            }
            ... on Page_Signaturepagefields_ContentBuilder_Cta {
              fieldGroupName
              cta {
                ${COMMON.LINK_FIELDS}
              }
            }
          }
        }

        template {
          templateName
        }

      }
    }
  }
`

export const PAGE_HOME = gql`
  query PageBySlug($id: ID!, $idType: PageIdType) {
    page(id: $id, idType: $idType) {
      slug
      title
      date

      featuredImage {
        node {
          sourceUrl(size: MEDIUM)
        }
      }

      dovetailPageHome {
        header {
          slider {
            image {
              ${COMMON.IMAGE_FIELDS}
            }
            imageMobile {
              ${COMMON.IMAGE_FIELDS}
            }
            videoUrl
            video {
              mediaItemUrl
            }            
            showInfobox
            title
            date
            description
            showCta
            link {
              ${COMMON.LINK_FIELDS}
            }
            status
          }
        }
        weBuildContent {
          headline
          title
          description
          link {
            ${COMMON.LINK_FIELDS}
          }
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          video
        }
        aboutUsContent {
          headline
          title
          description
          link {
            ${COMMON.LINK_FIELDS}
          }
          image {
            ${COMMON.IMAGE_FIELDS}
          }
        }
        testimonialsContent {
          headline
          title
          items {
            image {
              ${COMMON.IMAGE_FIELDS}
            }
            testimonial
            name
          }
        }
      }

      ${SEO.SEO_CONFIG}
    }
  }
`

// About Us Page
export const PAGE_ABOUT = gql`
  query PageAboutUs($pageId: ID!) {
    pageBy:page(id: $pageId, idType:DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      dovetailPageAbout {
        header {
          mainTitle
          headerHeading
          headerTitle
          headerDescription
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          video {
            mediaItemUrl
          }
        }
        whereWeBuildContent {
          headline
          title
          description
          link {
            ${COMMON.LINK_FIELDS}
          }
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          imageTitle,
          imageSubtitle
        }
        howWeBuildContent {
          headline
          title
          description
          link {
            ${COMMON.LINK_FIELDS}
          }
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          imageTitle,
          imageSubtitle
        }
        preconstructionContent {
          headline
          title
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          items {
            title
            description
          }
          visible
        }
        actualConstructionContent {
          headline
          title
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          items {
            title
            description
          }
          visible
        }
        keepingOurPromisesContent {
           headline
          title
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          items {
            title
            description
          }
          visible
        }
        ourHistoryContent {
          headline
          title
          description
          link {
            ${COMMON.LINK_FIELDS}
          }
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          secondaryImage {
            ${COMMON.IMAGE_FIELDS}
          }
        }
      }
    }
  }
`

// Contact Page
export const PAGE_CONTACT = gql`
  query PageContact($pageId: ID!) {
    pageData: page(id: $pageId, idType: DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      dovetailPageContact {
        header {
          title
          contactInfoHeadline
          items {
            title
            contact {
              contactImage {
                ${COMMON.IMAGE_FIELDS}
              }
              name
              position
              phone
            }
          }
        }
        ourOffice {
          headline
          title
          description
          link {
            ${COMMON.LINK_FIELDS}
          }
          image {
            ${COMMON.IMAGE_FIELDS}
          }
        }
      }
    }
  }
`

// Giving Back Page
export const PAGE_GIVING_BACK = gql`
  query PageGivingBack($pageId: ID!, $pressTerm: [String]!) {
    pageData: page(id: $pageId, idType: DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      dovetailPageGivingBack {
        header {
          title          
        }
        content {
          headline
          title          
        }
      }
    }

    latestPressNews: posts(
      where: {
        taxQuery: {
          taxArray: [
            { terms: $pressTerm, taxonomy: NEWSCATEGORY, field: SLUG }
          ]
          relation: AND
        }
        orderby: { field: DATE, order: DESC }
      }
      first: 8
    ) {
      nodes {
        title
        uri
        date

        signaturePostNewsFields {
          contentBuilder {
            ... on Post_Signaturepostnewsfields_ContentBuilder_Headline {
              fieldGroupName
              text
            }
          }
          headerImage {
            ${COMMON.IMAGE_FIELDS}
          }
          headerLogo {
            ${COMMON.IMAGE_FIELDS}
          }
        }
      }
    }
  }
`

// Projects Page
export const PAGE_PROJECTS = gql`
  query PageProjects($pageId: ID!, $homeId: ID!) {
    homeData: page(id: $homeId, idType: DATABASE_ID) {
      dovetailPageHome {
        header {
          slider {
            image {
              ${COMMON.IMAGE_FIELDS}
            }
            imageMobile {
              ${COMMON.IMAGE_FIELDS}
            }
            showInfobox
            title
            date
            description
            showCta
            link {
              ${COMMON.LINK_FIELDS}
            }
            status
          }
        }

        testimonialsContent {
          headline
          title
          items {
            image {
              ${COMMON.IMAGE_FIELDS}
            }
            testimonial
            name
          }
        }
      }
    }

    pageData: page(id: $pageId, idType: DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      dovetailPageProjects {
        headline
        title
        description
        signatureProjects {
          visible
          title
          description
          projects {
            ... on Project {
              title
              uri
              SingleProjectFields {
                headerImage {
                  ${COMMON.IMAGE_FIELDS}
                }
                headerListingImage {
                  ${COMMON.IMAGE_FIELDS}
                }
      
                location {
                  ... on Location {
                    id
                    locationsFields {
                      location {
                        stateShortname
                      }
                    }
                  }
                }
							}
            }
          }
        }
      }
    }

    projectsList: projects(where: {taxQuery: {taxArray: {taxonomy: PROJECTCATEGORY, terms: "${SITENAME}", field: SLUG, includeChildren: true}}, orderby: {field: MENU_ORDER, order: ASC}}, first: 9999) {      
      nodes {
        title
        uri
        SingleProjectFields {
          headerImage {
            ${COMMON.IMAGE_FIELDS}
          }
          headerListingImage {
            ${COMMON.IMAGE_FIELDS}
          }

          location {
            ... on Location {
              id
              locationsFields {
                location {
                  stateShortname
                }
              }
            }
          }
        }        
      }
    }
  }
`

// Careers Page
export const PAGE_CAREERS = gql`
  query PageCareers($pageId: ID!) {
    pageBy:page(id: $pageId, idType:DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      signaturePageCareersFields {
        benefits {
          headline
          items {
            description
            title
          }
          title
        }
        header {
          description
          headline
          title
          link {
            label
            url
          }
          link2 {
            label
            url
          }
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          video {
            mediaItemUrl
          }          
        }
        joinUs {
          description
          headline
          title
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          video {
            mediaItemUrl
          }          
          link {
            label
          }
        }
        openPositions {
          headline
          title
        }
        statistics {
          quantity
          title
        }
        whereWeBuild {
          description
          headline
          subtitle
          title
          link {
            ${COMMON.LINK_FIELDS}
          }
        }
        locations {
          title 
          content {
            title
            subtitle1
            text
            legend1
            legend2
            legend3
            legend4
          }
        }
      }
    }
  }
`

// Careers Details Page
export const PAGE_CAREERS_DETAILS = gql`
  query PageCareersDetail($pageIdCareers: ID!, $pageIdDetails: ID!) {
    careers: page(id: $pageIdCareers, idType: DATABASE_ID) {
      signaturePageCareersFields {
        benefits {
          headline
          items {
            description
            title
          }
          title
        }
      }
    }
    details: page(id: $pageIdDetails, idType: DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      signaturePageCareersDetailFields {
        sidebar {
          imageCaption
          image {
            ${COMMON.IMAGE_FIELDS}
          }
        }
        video {
          heading
          title
          video {
            mediaItemUrl
          }
          videoPoster {
            ${COMMON.IMAGE_FIELDS}
          }
        }
      }
    }
  }
`

// Legal Pages
export const PAGE_LEGALS = gql`
  query PageLegals($pageId: ID!) {
    pageBy:page(id: $pageId, idType:DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      signaturePageWarrantyFields {
        content {
          content {
            description
            headline
            title
            showCta
            link {
              ${COMMON.LINK_FIELDS}
            }            
          }
        }

        sidebar {
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          imageCaption
        }

        header {
          title
        }
      }
    }
  }
`

// Resorts / Residentials pages
export const PAGE_RESORTS = gql`
  query PageResorts($pageId: ID!, $term: [String]!) {
    page(id: $pageId, idType:DATABASE_ID) {
      ${SEO.SEO_CONFIG}

      signaturePageResortFields {
        postConstruction {
          cards {
            title
            description
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
          headline
          title
        }

        constManagement {
          headline
          title
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          items {
            description
            title
          }
        }
        header {
          tagline
          title
          images {
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
        }

        preconServices {
          headline
          title
          image {
            ${COMMON.IMAGE_FIELDS}
          }
          items {
            description
            title
          }
        }

        ourProjects {
          description
          headline
          title
        }
      }
    }

    projectsList: projects(where: {taxQuery: {taxArray: {field: SLUG, includeChildren: true, taxonomy: PROJECTCATEGORY, terms: $term}}, orderby: {field: MENU_ORDER, order: ASC}}, first: 9999) {
      nodes {
        title
        uri
        SingleProjectFields {
          headerImage {
            ${COMMON.IMAGE_FIELDS}
          }
          headerListingImage {
            ${COMMON.IMAGE_FIELDS}
          }

          location {
            ... on Location {
              id
              locationsFields {
                location {
                  stateShortname
                }
              }
            }
          }
        }        
      }
    }    
  }
`

// Media Page
export const PAGE_MEDIA = gql`
  query PageMedia($pageId: ID!, $pressTerm: [String]!) {
    pageData:page(id: $pageId, idType:DATABASE_ID) {
      ${SEO.SEO_CONFIG}
      
      signaturePageMediaFields {
        awards {
          headline
          title
          awards {
            date
            subtitle
            title
            externalLink
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
        }
        books {
          headline
          title
          books {
            description
            externalLink
            headline
            title
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
        }

        header {
          title
        }

        inThePress {
          headline
          title
        }
        magazineFeatures {
          headline
          title
          magazines {
            externalLink
            headline
            title
            description
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
        }
      }
    }

    latestPressNews: posts(
      where: {
        taxQuery: {
          taxArray: [
            { terms: $pressTerm, taxonomy: NEWSCATEGORY, field: SLUG }
          ]
          relation: AND
        }
        orderby: { field: DATE, order: DESC }
      }
      first: 8
    ) {
      nodes {
        title
        uri
        date

        signaturePostNewsFields {
          contentBuilder {
            ... on Post_Signaturepostnewsfields_ContentBuilder_Headline {
              fieldGroupName
              text
            }
          }
          headerImage {
            ${COMMON.IMAGE_FIELDS}
          }
          headerLogo {
            ${COMMON.IMAGE_FIELDS}
          }
        }
      }
    }

  }
`

// Media Page (AWARDS SECTION)
export const PAGE_MEDIA_AWARDS = gql`
  query PageMediaAwards($mediaId: ID!, $magazineId : ID!) {
    pageData:page(id: $mediaId, idType:DATABASE_ID) {
      signaturePageMediaFields {
        magazineFeatures {
          title
          magazines {
            externalLink
            headline
            title
            image {
              ${COMMON.IMAGE_FIELDS}
            }
          }
        }
      }
    }

    seo:page(id: $magazineId, idType:DATABASE_ID) {
      ${SEO.SEO_CONFIG}      
    }    
  }
`

// Get all pages
export const ALL_PAGES_QUERY = gql`
  query AllPages {
    pages {
      nodes {
        content(format: RAW)
        slug
        title
        date
        featuredImage {
          node {
            altText
            id
            caption
            sourceUrl(size: MEDIUM)
          }
        }
      }
    }
  }
`

// Get all 'preview' pages
export const ALL_PREVIEW_PAGES_QUERY = gql`
  query AllPreviewPages {
    pages(where: { status: DRAFT }) {
      nodes {
        content(format: RAW)
        slug
        title
        date
        featuredImage {
          node {
            altText
            id
            caption
            sourceUrl(size: MEDIUM)
          }
        }
      }
    }
  }
`
